<div class="container-fluid padding-0">
  <div class="inbox-container">
    <div class="ltms-tabs lato-bold-dark">
      <div class="ltms-tab" *ngIf="tabVisblity.customer_feedback"
        [ngClass]="{ 'ltms-active-tab': activeTab === 'customer_feedback' }" (click)="toggleTab('customer_feedback')">
        Customer Feedback</div>
      <div class="ltms-tab" *ngIf="tabVisblity.verbatim" [ngClass]="{ 'ltms-active-tab': activeTab === 'verbatim' }"
        (click)="toggleTab('verbatim')">Verbatim</div>
      <!-- <div class="ltms-tab" [ngClass]="{ 'ltms-active-tab': activeTab === 'sent_items' }"
        (click)="toggleTab('sent_items')">Sent items</div> -->
      <div class="ltms-tab" *ngIf="tabVisblity.wordcloud" [ngClass]="{ 'ltms-active-tab': activeTab === 'wordcloud' }"
        (click)="toggleTab('wordcloud')">WordCloud</div>
    </div>
    <div *ngIf="queryParams$ | async as params">
      <div *ngIf="activeTab === 'customer_feedback' && tabVisblity.customer_feedback">
        <litmus-feed-list-view [isAccountFeeds]="false"></litmus-feed-list-view>
      </div>
      <div *ngIf="activeTab === 'verbatim' && tabVisblity.verbatim">
        <app-verbatim-home [isAccountLevel]="false"></app-verbatim-home>
      </div>
      <!-- <div *ngIf="activeTab === 'sent_items'">
        <app-project-inbox-sent></app-project-inbox-sent>
      </div> -->
      <div *ngIf="activeTab === 'wordcloud' && tabVisblity.wordcloud">
        <app-wordcloud></app-wordcloud>
      </div>
    </div>
  </div>
</div>